module.exports = __webpack_public_path__ + "media/assets/icons/sidebar_arrow-b6a4da2e04d7b2a6656d7657501638d5.svg";